import React, {
  useEffect,
  useState,
} from "react";

const ClassMonitor = () => {

  const [data, setData] =
    useState([]);

  useEffect(() => {

    fetch(
      "https://stjosephweb.ilakshyaerp.in/api/class-monitor/all"
    )
      .then((res) => res.json())
      .then((res) =>
        setData(
          Array.isArray(res)
            ? res
            : []
        )
      );

  }, []);

  return (

    <section className="w-full bg-[#F5F4DF] min-h-screen py-10">

      <div className="max-w-6xl mx-auto px-4">

        {/* DATA */}
        {
          data.length > 0
            ? (
              data.map(
                (item) => (

                  <div
                    key={item.id}
                    className="mb-12 border-[3px] border-[#F59E0B] bg-white shadow-lg"
                  >

                    {/* TITLE */}
                    <div className="bg-[#FCD58A] border-b-[3px] border-[#F59E0B]">

                      <h2 className="text-center text-2xl md:text-4xl font-bold text-[#072F5F] py-4 uppercase">

                        {item.title}

                      </h2>

                    </div>

                    {/* CONTENT */}
                    <div className="p-4">

                      {
                        item.type ===
                        "image"
                          ? (

                            <img
                              src={`https://stjosephweb.ilakshyaerp.in/uploads/class-monitor/${item.file}`}
                              alt=""
                              className="w-full rounded-lg"
                            />

                          )
                          : (

                            <iframe
                              src={`https://stjosephweb.ilakshyaerp.in/uploads/class-monitor/${item.file}`}
                              title=""
                              className="w-full h-[900px]"
                            />

                          )
                      }

                    </div>

                  </div>
                )
              )
            )
            : (

              <div className="text-center py-24">

                <h2 className="text-4xl font-bold text-[#072F5F]">

                  No Data Available

                </h2>

              </div>
            )
        }

      </div>

    </section>
  );
};

export default ClassMonitor;